import React from 'react';
import { TopBar } from './TopBar';
import { HeaderLogo } from './HeaderLogo';
import { DesktopNav } from './DesktopNav';
import { QuickActions } from './QuickActions';
import { MobileMenu } from './MobileMenu';
export function Header() {
  return <>
      <TopBar data-id="element-142" />

      <header className="sticky top-0 z-50 w-full" style={{
      backgroundColor: '#1e3d2f',
      boxShadow: '0 2px 12px rgba(0,0,0,0.4)'
    }} data-id="element-143">
        <div className="flex items-center justify-between px-4 py-1" data-id="element-144">
          <div className="max-w-[1280px] w-full mx-auto flex items-center justify-between gap-4" data-id="element-145">
            <HeaderLogo data-id="element-146" />
            <DesktopNav data-id="element-147" />
            <QuickActions data-id="element-148" />
            <MobileMenu data-id="element-149" />
          </div>
        </div>
      </header>
    </>;
}